import React, { PureComponent, Fragment } from 'react';
import cx from 'classnames';

import Icon from '~/core/scripts/components/Icon';

const socialLinkUrl = encodeURIComponent(ARTICLE_CONFIG.meta.ogUrl);

function getSentence(sentences, correctness) {
  if (correctness < 0.2) {
    return sentences[0];
  }

  if (correctness < 0.5) {
    return sentences[1];
  }

  if (correctness < 0.7) {
    return sentences[2];
  }

  if (correctness <= 0.9) {
    return sentences[3];
  }

  return sentences[4];
}

function getFbLink(text) {
  return `https://www.facebook.com/sharer/sharer.php?u=${socialLinkUrl}&t=${encodeURIComponent(text)}`;
}

function getTwitterLink(text) {
  return `https://twitter.com/intent/tweet?source=${socialLinkUrl}&text=${encodeURIComponent(text)}%20${ARTICLE_CONFIG.meta.ogUrl}`;
}

class Result extends PureComponent {
  state = {
    expanded: true
  }

  onToggleExpand() {
    this.setState(prevState => ({
      expanded: !prevState.expanded
    }));
  }

  renderSimpleResult() {
    return (
      <div className="result__simple">
        {this.props.questions.map((q, i) => (
          <div
            key={`resultitem__${q.id}`}
            className={cx('result__simple-item', { finished: q.finished, correct: q.correct })}
          >
            {i + 1}
          </div>
        ))}
      </div>
    );
  }

  renderResult() {
    const { questions, sentences } = this.props;
    const { expanded } = this.state;
    const correctAnswers = questions.reduce((res, item) => {
      if (item.correct) {
        res++;
      }

      return res;
    }, 0);
    const expandIcon = expanded ? 'down' : 'up';
    const correctness = correctAnswers / questions.length;
    const ort =  ARTICLE_CONFIG.ort || 'NRW';
    const socialText = `Orte nur anhand der Gebäudeumrisse erkennen: Ich habe ${correctAnswers} von ${questions.length} richtig erkannt. Hier geht's zum ${ort}-Quiz:`;

    return (
      <div className="result__finished">
        <div className="result__finished-expand" onClick={() => this.onToggleExpand()}>
          <Icon type={expandIcon} key={expandIcon} />
        </div>
        {expanded && (
          <Fragment>
            <div className="result__finished-title">
              {getSentence(sentences, correctness)}
            </div>
            <div className="result__finished-subtitle">
              Sie haben {correctAnswers} von {questions.length} Orten richtig erkannt.
            </div>

            <div className="result__finished-social">
              <a className="btn fb" target="_blank" href={getFbLink(socialText)}>
                <Icon type="facebook" /> Auf Facebook teilen
              </a>
              <a className="btn tw" target="_blank" href={getTwitterLink(socialText)}>
                <Icon type="twitter" /> Auf Twitter teilen
              </a>
            </div>
          </Fragment>
        )}
        {this.renderSimpleResult()}
      </div>
    );
  }

  render() {
    const { questions } = this.props;
    const totalAnswered = questions.reduce((res, item) => {
      if (item.finished) {
        res++;
      }

      return res;
    }, 0);
    const finished = totalAnswered === this.props.questions.length;
    const resultClasses = cx('result', this.props.modifiers, { expanded: this.state.expanded, finished });

    return (
      <div className={resultClasses}>
        <div className="result__inner layout-small">
          {finished ? this.renderResult() : this.renderSimpleResult()}
        </div>
      </div>
    );
  }
}

export default Result;
